import React, { useState, useEffect, useCallback } from "react";
import { logoLight,logoDark,shareImg } from "../utils";
import { navLists } from "../constants";
import Hamburger from "./Hamburger";
import ShareQRcode from './ShareQRcode.jsx'

export default function Navbar({ theme, setTheme }) {
  const [isOpen, setIsOpen] = useState(false);
  const [showBackToTop, setShow]  = useState(false);
  // 打开 / 关闭抽屉
  const openDrawer = () => setIsOpen(true);
  const closeDrawer = () => setIsOpen(false);

  // 初始化时根据 theme 添加 class
  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  // 切换主题
  const toggleTheme = () => {

  }
  function sharePage(options = {}) {
    const {
      title = document.title,
      text = '分享这个页面给你～',
      url = window.location.href
    } = options;

    if (navigator.share) {
      navigator.share({ title, text, url })
        .then(() => console.log('✅ 分享成功'))
        .catch(err => console.warn('❌ 用户取消或分享失败：', err));
    } else {
      // 不支持 Web Share API 的情况
      const shareText = `${title}\n${text}\n${url}`;
      copyToClipboard(shareText);
      alert('当前浏览器不支持系统分享，链接已复制到剪贴板');
    }
  }

  // 辅助函数：复制文本到剪贴板
  function copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
  // 汉堡按钮
  const toggleHamburger = useCallback(() => setIsOpen(prev => !prev), []);

  /* 监听滚动 */
  useEffect(() => {
    const onScroll = () =>
      setShow(window.scrollY > window.innerHeight);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* 回到顶部 */
  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <div className="fixed top-0 left-0 w-[100vw] z-[999]">
        <header className="m-[20px] w-[calc(100vw-40px)] rounded-2xl backdrop-blur py-4 border-2 border-white sm:w-[calc(100%-60px)] sm:px-0 px-0 flex justify-between items-center bg-white/35 text-gray-800 dark:bg-zinc/90 dark:text-gray-100 transition-colors duration-1000">
          <nav className="flex w-full items-center justify-between sm:justify-center px-4 sm:px-0">
            <img src={theme === 'dark' ? logoDark : logoLight}  alt="logo"  className="transition-opacity duration-1000 h-8" style={{ userDrag: 'none',userSelect: 'none',MozUserSelect: 'none',WebkitUserDrag: 'none',WebkitUserSelect: 'none' }} />
            {/* 桌面端导航 */}
            <div className="flex justify-center max-sm:hidden">
              {navLists.map((nav,index) => (
                index === 0?
                (<a
                  onClick={showBackToTop ? scrollToTop : undefined}
                  key={nav.value}
                  style={{fontFamily:'Sans'}}
                  className="px-5 font-bold text-lg cursor-pointer text-dark-black hover:text-black dark:text-gray dark:hover:text-white transition-colors transition-1000"
                >
                  {showBackToTop ? "回到顶部" : ''}
                </a>)
                :(<a
                  href={`#${nav.value}`}
                  key={nav.value}
                  style={{fontFamily:'Sans'}}
                  className="px-5 text-lg cursor-pointer text-dark-black hover:text-black dark:text-gray dark:hover:text-white transition-colors transition-1000"
                >
                  {nav.label}
                </a>)
              ))}
            </div>

            {/* 右侧按钮 */}
            <div className="flex items-center gap-4">
              {/* <button onClick={toggleTheme} className="text-gray-800 dark:text-gray-100 transition-colors duration-300 absolute top-[16px] right-[10px]">
                <div className="rounded-[100%] w-8 h-8 flex items-center justify-center" >
                  <svg t="1760425474123" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7366" width="24" height="24"><path d="M865.922728 583.211878c-16.276708 0-29.580712 13.246699-29.667693 29.727045l0 215.125569c0 17.992793-14.58723 32.637328-32.520671 32.637328L181.762717 860.70182c-17.935488 0-32.520671-14.645558-32.520671-32.637328L149.242046 292.155966c0-17.992793 14.586207-32.637328 32.520671-32.637328l291.230897 0c16.304338-0.029676 29.580712-13.363356 29.580712-29.724998 0-16.392342-13.276375-29.727045-29.610388-29.727045l-295.336402 0c-48.358381 0-87.721901 39.450501-87.721901 87.925538l0 544.205493c0 48.475038 39.36352 87.925538 87.721901 87.925538l630.239961 0c48.358381 0 87.720877-39.450501 87.720877-87.925538L895.588375 612.762915C895.501394 596.458577 882.19739 583.211878 865.922728 583.211878z" fill="#333333" p-id="7367"></path><path d="M930.818761 338.183256l0-0.318248L727.07645 133.511783l-6.435573-6.259564-0.814552 0.844228c-4.511757-2.532683-9.606799-3.873214-14.876826-3.873214-16.974603 0-30.774911 13.829983-30.774911 30.832216 0 5.298679 1.338485 10.393721 3.873214 14.907525l-0.903579 0.931209 141.845589 142.224212-145.573493 0.057305C436.396091 342.726735 378.197598 489.375723 361.049033 717.050096c0 17.004279 13.800307 30.832216 30.772864 30.832216 13.858636 0 25.620517-9.229199 29.464055-21.893636l1.397836-8.181333c18.022469-215.329207 60.470233-321.567833 251.839749-342.937536l144.466276 0L683.433464 510.804778l-5.502317 7.744381c-1.951445 4.104481-2.969635 9.112542-2.969635 13.654998 0 17.002232 13.799284 30.832216 30.772864 30.832216 4.832052 0 10.160407-1.164522 14.439874-3.37691L929.954067 350.740246c1.860371-1.305739 4.140297-4.52506 4.140297-6.970762C934.093341 341.323782 932.679132 339.488994 930.818761 338.183256z" fill="#333333" p-id="7368"></path></svg>
                </div>
              </button> */}
              <ShareQRcode></ShareQRcode>
              <div className="sm:hidden flex items-center gap-4">
                <Hamburger isOpen={isOpen} onClick={toggleHamburger} />
              </div>
            </div>
          </nav>
        </header>
      </div>
      {/* 抽屉 + 遮罩 */}
      <div
        className={`sm:hidden z-[9999] w-[100vw] fixed inset-0  bg-black/10 dark:bg-black/50 transition-opacity duration-300 ${
          isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={closeDrawer}
      >
        <div
          className={`fixed relative top-0 left-0 w-2/5 h-full bg-white/95 dark:bg-black/95 transition-transform duration-300 ease-out ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col items-start px-8 pt-10 space-y-6">
            <img
              src={theme === "dark" ? logoDark : logoLight}
              alt="logo"
              style={{
                height: "36px",
                userDrag: "none",
                userSelect: "none",
                MozUserSelect: "none",
                WebkitUserDrag: "none",
                WebkitUserSelect: "none",
              }}
              className="transition-opacity duration-1000"
            />
            {navLists.map((nav) => (
              <a
                href={`#${nav.value}`}
                key={nav.value}
                className="text-base cursor-pointer text-dark-black hover:text-black dark:text-gray dark:hover:text-white transition-colors transition-1000"
                onClick={closeDrawer}
              >
                {nav.label}
              </a>
            ))}
            {/* <div className="absolute left-6 bottom-40" onTouchStart={ sharePage }>
              <svg t="1760425474123" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7366" width="24" height="24">
                <path d="M865.922728 583.211878c-16.276708 0-29.580712 13.246699-29.667693 29.727045l0 215.125569c0 17.992793-14.58723 32.637328-32.520671 32.637328L181.762717 860.70182c-17.935488 0-32.520671-14.645558-32.520671-32.637328L149.242046 292.155966c0-17.992793 14.586207-32.637328 32.520671-32.637328l291.230897 0c16.304338-0.029676 29.580712-13.363356 29.580712-29.724998 0-16.392342-13.276375-29.727045-29.610388-29.727045l-295.336402 0c-48.358381 0-87.721901 39.450501-87.721901 87.925538l0 544.205493c0 48.475038 39.36352 87.925538 87.721901 87.925538l630.239961 0c48.358381 0 87.720877-39.450501 87.720877-87.925538L895.588375 612.762915C895.501394 596.458577 882.19739 583.211878 865.922728 583.211878z" fill="#333333" p-id="7367"></path>
                <path d="M930.818761 338.183256l0-0.318248L727.07645 133.511783l-6.435573-6.259564-0.814552 0.844228c-4.511757-2.532683-9.606799-3.873214-14.876826-3.873214-16.974603 0-30.774911 13.829983-30.774911 30.832216 0 5.298679 1.338485 10.393721 3.873214 14.907525l-0.903579 0.931209 141.845589 142.224212-145.573493 0.057305C436.396091 342.726735 378.197598 489.375723 361.049033 717.050096c0 17.004279 13.800307 30.832216 30.772864 30.832216 13.858636 0 25.620517-9.229199 29.464055-21.893636l1.397836-8.181333c18.022469-215.329207 60.470233-321.567833 251.839749-342.937536l144.466276 0L683.433464 510.804778l-5.502317 7.744381c-1.951445 4.104481-2.969635 9.112542-2.969635 13.654998 0 17.002232 13.799284 30.832216 30.772864 30.832216 4.832052 0 10.160407-1.164522 14.439874-3.37691L929.954067 350.740246c1.860371-1.305739 4.140297-4.52506 4.140297-6.970762C934.093341 341.323782 932.679132 339.488994 930.818761 338.183256z" fill="#333333" p-id="7368"></path>
              </svg>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
